import { Controller } from "@hotwired/stimulus"
import { cable } from "@hotwired/turbo-rails"

const PING_EVERY = 30_000
const MAX_CIRCLES = 5

// Lives on <body>. Tells PresenceChannel which page this tab is on, keeps
// the row alive, reports the title of any remote modal it opens, and renders
// the viewer list the channel sends back into #presence (minus this user).
export default class extends Controller {
  static values = { path: String, title: String, organizationId: Number, userId: Number }

  async connect() {
    if (!this.userIdValue) return

    this.tab = crypto.randomUUID()
    const consumer = await cable.getConsumer()
    this.subscription = consumer.subscriptions.create(
      { channel: "PresenceChannel", tab: this.tab, path: this.pathValue, title: this.titleValue, organization_id: this.organizationIdValue || null },
      { received: (data) => this.render(data.html) }
    )
    this.timer = setInterval(() => this.subscription.perform("ping"), PING_EVERY)
    this.element.addEventListener("turbo:frame-load", this.modalLoaded)
    this.element.addEventListener("hidden.bs.modal", this.modalClosed)
  }

  disconnect() {
    clearInterval(this.timer)
    this.subscription?.unsubscribe()
    this.element.removeEventListener("turbo:frame-load", this.modalLoaded)
    this.element.removeEventListener("hidden.bs.modal", this.modalClosed)
  }

  modalLoaded = (event) => {
    if (event.target.id !== "remote_modal") return
    const title = event.target.querySelector(".modal-title")?.textContent?.trim()
    if (title) this.subscription?.perform("editing", { title })
  }

  modalClosed = () => this.subscription?.perform("editing", { title: null })

  render(html) {
    const slot = document.getElementById("presence")
    if (!slot) return
    slot.innerHTML = html
    slot.querySelector(`[data-user-id="${this.userIdValue}"]`)?.remove()
    this.truncate(slot)
    slot.hidden = slot.childElementCount === 0
  }

  // Five circles, editors first, then one "+N" whose tooltip names the rest.
  truncate(slot) {
    const viewers = [...slot.children]
    if (viewers.length <= MAX_CIRCLES) return

    const editing = viewers.filter(v => v.classList.contains("presence-viewer--editing"))
    const shown = new Set([...new Set([...editing, ...viewers])].slice(0, MAX_CIRCLES))
    const rest = viewers.filter(v => !shown.has(v))
    rest.forEach(v => v.remove())

    const more = document.createElement("div")
    more.className = "member-component member-circle presence-viewer presence-viewer--more"
    more.textContent = `+${rest.length}`
    more.title = slot.dataset.moreLabel.replace("%{names}", rest.map(v => v.dataset.name).join(", "))
    more.dataset.controller = "tooltip"
    more.dataset.tooltipPlacementValue = "bottom"
    slot.append(more)
  }
}
